import { render, staticRenderFns } from "./example02.vue?vue&type=template&id=d39dc20c&scoped=true&"
import script from "./example02.vue?vue&type=script&lang=js&"
export * from "./example02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39dc20c",
  null
  
)

export default component.exports